import axios from 'axios'

const state = {
  notifications: [],
  currentNotification: null,
  loading: false,
  error: null
}

const mutations = {
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications
  },
  SET_CURRENT_NOTIFICATION(state, notification) {
    state.currentNotification = notification
  },
  ADD_NOTIFICATION(state, notification) {
    state.notifications.push(notification)
  },
  UPDATE_NOTIFICATION(state, updatedNotification) {
    const index = state.notifications.findIndex(c => c._id === updatedNotification._id)
    if (index !== -1) {
      state.notifications.splice(index, 1, updatedNotification)
    }
  },
  DELETE_NOTIFICATION(state, notificationId) {
    state.notifications = state.notifications.filter(c => c._id !== notificationId)
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

const actions = {
  async fetchNotifications({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get('/notifications')
      commit('SET_NOTIFICATIONS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors du chargement des notifications')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchNotification({ commit }, notificationId) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.get(`/notifications/${notificationId}`)
      commit('SET_CURRENT_NOTIFICATION', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors du chargement de la notification')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createNotification({ commit }, notificationData) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.post('/notifications', notificationData)
      commit('ADD_NOTIFICATION', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors de la création de la notification')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateNotification({ commit }, { notificationId, notificationData }) {
    commit('SET_LOADING', true)
    try {
      const response = await axios.put(`/notifications/${notificationId}`, notificationData)
      commit('UPDATE_NOTIFICATION', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors de la mise à jour de la notification')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteNotification({ commit }, notificationId) {
    commit('SET_LOADING', true)
    try {
      await axios.delete(`/notifications/${notificationId}`)
      commit('DELETE_NOTIFICATION', notificationId)
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Erreur lors de la suppression de la notification')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const getters = {
  allNotifications: state => state.notifications,
  currentNotification: state => state.currentNotification,
  isLoading: state => state.loading,
  error: state => state.error,
  getNotificationById: state => id => state.notifications.find(c => c._id === id),
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 